import { useLocalStore } from 'mobx-react-lite';

import bus from 'APP/packages/bus';

export default ({ focusHandler, list, common }) => {
  const presenter = useLocalStore(() => ({
    onSelectMention() {
      const selectedMention = list.mentions[focusHandler.focusedIndex];

      bus.messaging.broadcastSelectMention(selectedMention);
      common.inputPanel.mention.reset();
    },
  }));

  return presenter;
};
